import type { DataLayersToolAction } from './dataLayers.action';
import {
  dataLayersToolBoundaryTerritoryGroupsCreated, dataLayersToolUpdateFinished, dataLayersToolUpdateStarted,
  onDataLayerTemplatesChanged,
} from './dataLayers.actionCreators';
import type { DataLayersToolState } from './dataLayers.state';

export const dataLayersToolInitialState: DataLayersToolState = {
  isUpdating: false,
  dataLayerTemplatesEtag: 0,
};

export const dataLayersToolReducer = (
  state = dataLayersToolInitialState,
  action: DataLayersToolAction
): DataLayersToolState => {
  if (dataLayersToolUpdateStarted.match(action)) {
    return {
      ...state,
      isUpdating: true,
    };
  }

  if (dataLayersToolBoundaryTerritoryGroupsCreated.match(action) || dataLayersToolUpdateFinished.match(action)) {
    return {
      ...state,
      isUpdating: false,
    };
  }

  if (onDataLayerTemplatesChanged.match(action)) {
    return {
      ...state,
      dataLayerTemplatesEtag: Date.now(),
    };
  }

  return state;
};
